import { Component, OnInit, OnDestroy } from '@angular/core';
import { EntityDatatableComponent } from '../../../core/components/entity-datatable/entity-datatable.component';
import { LiftBoardParameterList } from '../../models/lift-board-parameter-list.model';
import { LiftBoardParameterService } from '../../services/lift-board-parameter.service';
import { LiftBoardParameterCriteria } from '../../models/lift-board-parameter.criteria';
import { ActivatedRoute, Router } from '@angular/router';
import { EntityListRefresh } from '../../../core/services/entity-list.refresh';
import { ProgressBarService } from '../../../core/services/progress-bar.service';
import { UINotificationService } from '../../../core/services/ui-notification.service';
import { LookupDetail } from '../../../core/models/lookup-detail.model';
import { HttpResponse } from '@angular/common/http';
import { NotificationType } from '../../../core/models/ui-notification.model';

@Component({
  selector: 'app-lift-board-parameter',
  templateUrl: './lift-board-parameter.component.html',
  styleUrls: ['./lift-board-parameter.component.css']
})
export class LiftBoardParameterComponent extends EntityDatatableComponent<LiftBoardParameterList, LiftBoardParameterCriteria, LiftBoardParameterService> implements OnInit, OnDestroy {
  liftBoards: LookupDetail[] = [];
  selectedBoard: LookupDetail;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private parameterService: LiftBoardParameterService,
    entityListRefresh: EntityListRefresh,
    progressBarService: ProgressBarService,
    private uiNotificationService: UINotificationService
  ) {
    super(
      'lift-board-parameter',
      new LiftBoardParameterCriteria(),
      entityListRefresh,
      parameterService,
      progressBarService
    );
  }

  ngOnInit() {
    this.initData(this.route.snapshot.data.parameters);
    this.entityList.forEach(item => {
      item.items = [];
    });
    const response: HttpResponse<LookupDetail[]> = this.route.snapshot.data.liftBoards;
    this.liftBoards = response.body;
    this.selectedBoard = this.liftBoards[0];
    this.criteria.liftBoardId = this.selectedBoard.id;
  }

  ngOnDestroy() {
    this.destroyData();
  }

  assetsTrackBy(index: number, param) {
    return param.id;
  }

  loadParam(param) {
    let criteria = new LiftBoardParameterCriteria();
    criteria.liftBoardId = this.selectedBoard.id;
    criteria.parentId = param.id;

    this.entityList.forEach(item => {
      item.items = [];
    });

    if (this.entityList.filter(item => item.id == param.id)[0].isOpened) {
      this.entityList.filter(item => item.id == param.id)[0].isOpened = false;
      return;
    }

    this.parameterService.get(criteria.paramsExport()).
      subscribe(items => {
        this.entityList.filter(item => item.id == param.id)[0].items = items.body;
        this.entityList.filter(item => item.id == param.id)[0].isOpened = true;
      });

    
  }

  selectBoard() {
    this.criteria.liftBoardId = this.selectedBoard.id;
    this.reloadData();
  }

  createLiftBoardParameterGroup() {
    this.router.navigate([{ outlets: { modal: ['create-lift-board-parameter-group', this.selectedBoard.id] } }]);
  }

  detailLiftBoardParameterGroup(id: number) {
    this.router.navigate([{ outlets: { modal: ['lift-board-parameter-group-detail', id] } }]);
  }

  createLiftBoardParameter() {
    this.router.navigate([{ outlets: { modal: ['create-lift-board-parameter', this.selectedBoard.id] } }]);
  }

  delete(id) {
    if (confirm('Chcete opravdu smazat parametr z karty ?')) {
      this.parameterService.delete(id)
        .subscribe(() => {
          this.uiNotificationService.add({
            type: NotificationType.Info,
            message: 'Akce proběhla úspěšně'
          });
          this.criteria.liftBoardId = this.selectedBoard.id;
          this.reloadData();
        });
    }   
  }
}
